/**
 * Trạng thái hoạt động
 * nddat1 30/01/2023
 */
export default {
  All: 'All',
  Active: 'Follow',
  InActive: 'Unfollow',
};
